import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }

import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WorkCalendarForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "work-calendars.table.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          placeholder: _ctx.$t('work-calendars.table.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})